module.exports = __webpack_public_path__ + "static/media/twitter.089a47ef.png";